import { Injectable } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { InspectionTemplate } from '@authority-labs/api-interfaces';
import { InspectionTypeEnum } from '@authority-labs/enums';
import { SelectInspectionTemplateDialogComponent } from './select-inspection-template-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class SelectInspectionTemplateDialogService {
  private dialogConfig: MatDialogConfig;

  constructor(private dialog: MatDialog) {
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.minWidth = '65vw';
  }

  show(
    inspectionType: InspectionTypeEnum
  ): MatDialogRef<SelectInspectionTemplateDialogComponent, InspectionTemplate> {
    this.dialogConfig.data = {
      inspectionType
    };
    return this.dialog.open<
      SelectInspectionTemplateDialogComponent,
      InspectionTemplate
    >(SelectInspectionTemplateDialogComponent, this.dialogConfig);
  }
}
